import React from 'react';
import PropTypes from 'prop-types';
import FlapBoard from '@components/FlapBoard';
import './style.scss';

const ABOUT_ROW = [
  { text: 'ABOUT', colors: ['indigo', 'indigo', 'indigo', 'indigo', 'indigo'] },
];

const SKILLS = ['React', 'TypeScript', 'JavaScript', 'Python', 'Node.js'];

const AboutPage = (props, context) => {
  const { theme: { colorHighlight, textPrimary, colorPrimary } } = context;

  return (
    <div id="about" className="about-page">
      <style jsx="true">{`
        .highlight { background-color: ${colorHighlight}; }
        ::selection { background-color: ${colorHighlight}; }
      `}</style>
      <div className="content-grid">
        <FlapBoard heading="h2" autoPlay={false} rows={ABOUT_ROW} />
        <div className="about-wrapper">
          <div className="about-content" style={{ color: textPrimary }}>
            <p className="about-lead reveal" style={{ '--reveal-delay': '0s' }}>
              I'm a Software Engineer at CVS Health and a Computer Science graduate from the University of Colorado Boulder.
            </p>
            <p className="reveal" style={{ '--reveal-delay': '0.12s' }}>
              I have a lot of experience working with front end web development and creating projects that I'm passionate about.
            </p>
            <p className="reveal" style={{ '--reveal-delay': '0.24s' }}>
              React, Python, and TypeScript are my main strengths — I've had ample time to work with them throughout my college career and professional life.
            </p>
            <div className="about-skills reveal" style={{ '--reveal-delay': '0.36s' }}>
              <span className="about-skills__label">Core Stack</span>
              <div className="about-chips">
                {SKILLS.map((skill) => (
                  <span
                    key={skill}
                    className="about-chip"
                    style={{ color: colorPrimary, borderColor: colorPrimary }}
                  >
                    {skill}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

AboutPage.contextTypes = {
  theme: PropTypes.any
};

export default AboutPage;



// WEBPACK FOOTER //
// ./src/pages/AboutPage/AboutPage.js